import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JobService } from 'src/@core/services/job/job.service';
import { DECIDE_LOOP_CHANGE, GET_LOOP_RUNS, PROJECT_API_KEY, START_LOOP_RUN } from 'src/@core/services/util/api.endpoints';
import { LoopConfig, LoopRunResponse, LoopRunsResponse, StartRunResponse, toLoopPayload } from './loop.logic';

@Injectable({ providedIn: 'root' })
export class LoopService {
  constructor(private http: HttpClient, private jobService: JobService) {}

  private headers(): HttpHeaders {
    return new HttpHeaders({ 'x-api-key': PROJECT_API_KEY, 'Content-Type': 'application/json' });
  }

  /** Saves through the same project update the rest of the app uses. */
  saveLoopConfig(profile: any, projectId: string, config: LoopConfig): Observable<any> {
    const form = new FormData();
    form.append('entityId', profile.entity.id);
    form.append('userId', profile.user.id);
    form.append('userName', profile.user.userMeta.name);
    form.append('projectId', projectId);
    form.append('loopConfig', JSON.stringify(toLoopPayload(config)));
    return this.jobService.updateHoaProject(form);
  }

  /** 202 {run_id, status}; 400 {message} when the loop is off; 409 {message} when a run is active. */
  startRun(profile: any, projectId: string): Observable<StartRunResponse> {
    const body = {
      entityId: profile.entity.id,
      projectId,
      userId: profile.user.id,
      userName: profile.user.userMeta.name
    };
    return this.http.post<StartRunResponse>(START_LOOP_RUN, body, { headers: this.headers() });
  }

  /** The newest runs (up to 200), newest first. */
  getRuns(entityId: string, projectId: string): Observable<LoopRunsResponse> {
    const params = new HttpParams().set('entity_id', entityId).set('project_id', projectId);
    return this.http.get<LoopRunsResponse>(GET_LOOP_RUNS, { headers: this.headers(), params });
  }

  /** One run with findings, test cases and changes. */
  getRun(entityId: string, projectId: string, runId: string): Observable<LoopRunResponse> {
    const params = new HttpParams().set('entity_id', entityId).set('project_id', projectId).set('run_id', runId);
    return this.http.get<LoopRunResponse>(GET_LOOP_RUNS, { headers: this.headers(), params });
  }

  decideChange(
    profile: any, projectId: string, runId: string, changeId: string, decision: string
  ): Observable<LoopRunResponse> {
    const body = {
      entityId: profile.entity.id,
      projectId,
      runId,
      changeId,
      userId: profile.user.id,
      decision
    };
    return this.http.post<LoopRunResponse>(DECIDE_LOOP_CHANGE, body, { headers: this.headers() });
  }
}
